import {
  BankTransferIcon,
  GiftCardIcon,
  OriginalPaymentMethodIcon,
  refundMethods,
  StoreCreditIcon,
} from '@reveni-io/reveni-ui'

export const getLabelByRefundMethodType = type => {
  const labels = {
    [refundMethods.bankTransfer]: 'Transferencia bancaria',
    [refundMethods.originalPaymentMethod]: 'Método de pago original',
    [refundMethods.storeCredit]: 'Crédito en tienda',
    [refundMethods.giftCard]: 'Tarjeta regalo',
  }

  return labels[type]
}

export const getBulletColor = (type, isInstant, theme) => {
  const backgroundColors = {
    [refundMethods.bankTransfer]: theme.colors.info.default,
    [refundMethods.originalPaymentMethod]: isInstant ? theme.colors.ai.default : theme.colors.ai.hover,
    [refundMethods.storeCredit]: isInstant ? theme.colors.success.default : theme.colors.success.onSurface,
    [refundMethods.giftCard]: isInstant ? theme.palette.pink.tone300 : theme.palette.pink.tone500,
  }

  return backgroundColors[type]
}

export const getIconByRefundMethodType = type => {
  const iconPaths = {
    [refundMethods.bankTransfer]: BankTransferIcon,
    [refundMethods.originalPaymentMethod]: OriginalPaymentMethodIcon,
    [refundMethods.storeCredit]: StoreCreditIcon,
    [refundMethods.giftCard]: GiftCardIcon,
  }

  return iconPaths[type]
}

export const getRefundMethodsData = (data, theme) => {
  return data.map(data => ({
    label: getLabelByRefundMethodType(data.type),
    isInstant: data.is_instant,
    amount: data.amount,
    percentage: Number(data.percentage),
    count: Number(data.count),
    bulletColor: getBulletColor(data.type, data.is_instant, theme),
    Icon: getIconByRefundMethodType(data.type),
    iconType: data.is_instant ? 'instant' : 'default',
  }))
}
